import React from 'react';
import classnames from 'classnames';

import {
  section,
  article,
  description,
  speakerWrap,
  title,
  speakerInner,
  avatar,
  name,
  position,
  speakerContainer,
  onDemandStyle,
} from 'sections/Webinar/Content/styles.module.scss';
import DownloadSlides from './components/DownloadSlides/index';
import useWindowSize from 'hooks/useWindowResize';

const ContentOnDemand = ({ data, slides = '' }) => {
  const { width } = useWindowSize();

  const content = data?.webinarOnDemandContentBody;

  const speakers = {
    title: data?.webinarOnDemandContentSpeakersTitle,
    list: data?.webinarOnDemandContentSpeakersList,
  };

  return (
    <section className={classnames(section, onDemandStyle)}>
      <div className="scr-wrap">
        <article className={article}>
          <div
            className={description}
            dangerouslySetInnerHTML={{ __html: content }}
          ></div>

          <div className={speakerWrap}>
            <p className={classnames('scr-h5', title)}>{speakers?.title}</p>

            {speakers?.list?.map((item) => {
              return (
                <div
                  className={speakerInner}
                  key={item?.webinarOnDemandSpeakerName}
                >
                  <img
                    src={item?.webinarOnDemandSpeakerAvatar?.sourceUrl}
                    alt={item?.webinarOnDemandSpeakerName}
                    className={avatar}
                  />

                  <div className={speakerContainer}>
                    <p className={classnames('scr-lead', name)}>
                      {item?.webinarOnDemandSpeakerName}
                    </p>
                    <p className={classnames('scr-reg', position)}>
                      {item?.webinarOnDemandSpeakerPosition}
                    </p>
                  </div>
                </div>
              );
            })}

            {width > 992 ? <DownloadSlides data={slides} /> : <></>}
          </div>
        </article>

        {width <= 992 ? <DownloadSlides data={slides} /> : <></>}
      </div>
    </section>
  );
};

export default ContentOnDemand;
